<template>
  <div ref="dropdownRef" class="tw-relative tw-block">
    <button
      type="button"
      data-testid="user-profile"
      v-bind="$attrs"
      class="tw-flex tw-cursor-pointer tw-items-center tw-border-none tw-bg-transparent tw-text-inherit"
      @click="
        () => {
          $analytics.trackElementClicked({ elementType: 'icon', text: 'profile' })
          toggleDropdown()
        }
      "
    >
      <PersonCircle class="tw-h-6 tw-w-6 tw-cursor-pointer md:tw-h-5 md:tw-w-5" />
      <span class="tw-hidden tw-pl-2 tw-pr-1 md:tw-inline">{{ $auth?.user?.firstName }}</span>
      <ChevronDown class="tw-ml-1 tw-h-3 tw-w-3 md:tw-ml-0" />
    </button>
    <div
      v-if="isDropdownOpen"
      class="tw-absolute tw-right-0 tw-top-full tw-z-10 tw-w-auto tw-min-w-[200px] tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-bg-white tw-shadow-lg"
    >
      <NuxtLink
        to="/profile"
        class="tw-flex tw-items-center tw-space-x-2 tw-rounded-t-lg tw-border-b tw-border-gray-200 tw-p-4 hover:tw-cursor-pointer hover:tw-bg-gray-100"
        @click="$analytics.trackElementClicked({ text: 'View profile', elementType: 'navigation' })"
      >
        <PersonIcon class="tw-h-5 tw-w-5 tw-text-gray-600" />
        <span class="tw-w-[130px] tw-text-base tw-font-normal tw-text-gray-800">View profile</span>
        <ChevronRight class="tw-h-5 tw-w-5 tw-text-gray-800" />
      </NuxtLink>

      <T2Button
        class="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-space-x-3 tw-rounded-b-lg tw-border-none tw-p-4 tw-font-normal tw-text-rose-600 hover:tw-bg-gray-100"
        @click="logout"
      >
        <ArrowExitIcon class="tw-h-5 tw-w-5" />
        <span class="tw-text-base tw-font-medium">Log out</span>
      </T2Button>
    </div>
  </div>
</template>

<script setup>
import T2Button from '@torticity/components/src/T2Button.vue'

import ArrowExitIcon from '~icons/fluent/arrow-exit-20-filled'
import ChevronDown from '~icons/fluent/chevron-down-12-filled'
import ChevronRight from '~icons/fluent/chevron-right-20-filled'
import PersonIcon from '~icons/fluent/person-20-filled'
import PersonCircle from '~icons/fluent/person-circle-20-filled'

defineOptions({ inheritAttrs: false })

const $analytics = useAnalytics()
const { $auth } = useNuxtApp()
const { logout: _logout } = useLogout()

const { isDropdownOpen, toggleDropdown, dropdownRef } = useProfileDropdown()

function logout() {
  $analytics.trackElementClicked({ text: 'Log out', elementType: 'navigation' })
  _logout()
}
</script>
